import { CellDimensions } from '../components/ColorChartCanvas'

// Base cell width (in pixels)
const BASE_CELL_WIDTH = 18

// Base cell margin (in pixels)
const BASE_CELL_MARGIN = 0.12

// Knitting cell dimensions (Intarsia/Fair Isle)
const KNITTING_CELL_DIMENSIONS: CellDimensions = {
  width: BASE_CELL_WIDTH,
  height: 12,
  margin: BASE_CELL_MARGIN
}

/**
 * Get cell dimensions based on craft and crochet stitch type
 * @param craft - The craft type (knitting, crochet, cross_stitch)
 * @param crochetStitchType - The crochet stitch type (sc, hdc, dc) - only used if craft is crochet
 * @returns CellDimensions object with width, height, and margin
 */
export function getCellDimensions(
  craft: 'knitting' | 'crochet' | 'cross_stitch' | null,
  crochetStitchType: 'sc' | 'hdc' | 'dc' | null
): CellDimensions {
  // Default to knitting if craft is not specified
  if (!craft) {
    return KNITTING_CELL_DIMENSIONS
  }

  switch (craft) {
    case 'knitting':
      return KNITTING_CELL_DIMENSIONS

    case 'cross_stitch':
      // Perfect squares for cross stitch
      return {
        width: BASE_CELL_WIDTH,
        height: BASE_CELL_WIDTH,
        margin: BASE_CELL_MARGIN
      }

    case 'crochet':
      // Crochet stitch type ratios (width : height)
      const stitchRatios: Record<'sc' | 'hdc' | 'dc', number> = {
        sc: 1.3,   // 1 : 1.3
        hdc: 1.6,  // 1 : 1.6
        dc: 2.1    // 1 : 2.1
      }

      // Default to SC if stitch type is not specified
      const ratio = crochetStitchType ? stitchRatios[crochetStitchType] : stitchRatios.sc

      return {
        width: BASE_CELL_WIDTH,
        height: BASE_CELL_WIDTH * ratio,
        margin: BASE_CELL_MARGIN
      }

    default:
      return KNITTING_CELL_DIMENSIONS
  }
}
